import { createContext, useContext, useLayoutEffect } from 'react';

export interface SeitenleistenWert {
  /** Meldet eine Anforderung an und gibt die Funktion zurueck, die sie wieder abmeldet. */
  fordereEinklappenAn: () => () => void;
}

export const SeitenleistenKontext = createContext<SeitenleistenWert | null>(null);

/**
 * Eine Seite, die die volle Breite braucht (die Freigabe in Teil B), ruft das auf. Solange
 * sie gemountet ist, ist die Seitenleiste eingeklappt; danach gilt wieder die gespeicherte
 * Wahl. Ausserhalb der Shell (Tests einzelner Seiten) tut der Aufruf nichts.
 *
 * `useLayoutEffect` statt `useEffect`: Die Anforderung muss vor dem ersten Anstrich der
 * Seite an die Shell gemeldet sein, sonst malt sie einen Sichtbarkeits-Frame lang mit
 * breiter Leiste und springt dann ins Schmale.
 */
export function useEingeklappteSeitenleiste(): void {
  const wert = useContext(SeitenleistenKontext);
  useLayoutEffect(() => wert?.fordereEinklappenAn(), [wert]);
}
